

app.controller('CIF1-CTRL',
    ['$scope', '$rootScope', '$http', '$window', '$q', '$filter',
    function ($scope, $rootScope, $http, $window, $q, $filter) {

    $scope.CIFInvestor = {}
    $scope.maxDate = new Date().toISOString().slice(0, 10);
    $scope.Kewarganegaraan = 'WNI / Indonesian';
    $scope.KewarganegaraanOption = ['WNI / Indonesian', 'Lainnya / Others'];
    $scope.IDLength = 16;
    $scope.chkSeumurHidup = true;
    $scope.DisabledSeumurHidup = true;

    $scope.IDCardCitySelected = '';
    $scope.DomicileCitySelected = '';
    $scope.NationalitySelected = '';
    $scope.IDCardCountrySelected = '';

    $scope.ListNationality = [];
    $scope.ListLookup = [];
    $scope.ListReligion = [];
    $scope.ListMarital = [];
    $scope.ListEducation = [];

    $scope.KewarganegaraanChange = function () {
        if ($scope.Kewarganegaraan == 'WNI / Indonesian') {
            $scope.IDLength = 16;
            $scope.chkSeumurHidup = true;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 102;
            $scope.CIFInvestor.IDCardCountry = 102;
            $scope.CIFInvestor.CopyID = true;
            $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
        }
        else if ($scope.Kewarganegaraan == 'Lainnya / Others') {
            $scope.IDLength = 8;
            $scope.chkSeumurHidup = false;
            $scope.DisabledSeumurHidup = true;
            $scope.CIFInvestor.Nationality = 0;
            $scope.CIFInvestor.IDCardCountry = 0;
            $scope.CIFInvestor.CopyID = false;
            $scope.CIFInvestor.IDCardExpireDate = '';
            $scope.CIFInvestor.IDCardCity = 0;
            $scope.CIFInvestor.IDCardKecamatan = '';
            $scope.CIFInvestor.IDCardKelurahan = '';
            $scope.CIFInvestor.IDCardRT = '';
            $scope.CIFInvestor.IDCardRW = '';
            $scope.CIFInvestor.IDCardAddress = '';
            $scope.IDCardCitySelected = '';
        }
    }

    $scope.selectNationality = function (item, model, label, event) {
        if (item.CIFCountryNID)
        {
            $scope.CIFInvestor.Nationality = item.CIFCountryNID;
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
            $scope.NationalitySelected = item;
            $scope.IDCardCountrySelected = item;
        }
        
    };

    $scope.selectIDCardCountry = function (item, model, label, event) {
        if(item.CIFCountryNID)
        {
            $scope.CIFInvestor.IDCardCountry = item.CIFCountryNID;
        }
    };

    $scope.selectIDCardCity = function (item, model, label, event) {
        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.IDCardCity = item.CIFProvinceCityNID;
        }
    };

    $scope.selectDomicileCity = function (item, model, label, event) {
        if (item.CIFProvinceCityNID) {
            $scope.CIFInvestor.DomicileCity = item.CIFProvinceCityNID;
        }
    };


    
    $scope.CopyFromID = function () {
        if ($scope.CIFInvestor.CopyID) {
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
            //$scope.CIFInvestor.DomicileCountry = $scope.CIFInvestor.IDCardCountry;
        }
        else {
            $scope.CIFInvestor.DomicilePostalCode = '';
            $scope.CIFInvestor.DomicileAddress = '';
            $scope.CIFInvestor.DomicileRT = '';
            $scope.CIFInvestor.DomicileRW = '';
            $scope.CIFInvestor.DomicileKelurahan = '';
            $scope.CIFInvestor.DomicileKecamatan = '';
            $scope.CIFInvestor.DomicileCity = 0;
            $scope.DomicileCitySelected = '';
            //$scope.CIFInvestor.DomicileCountry = '';
        }
        
    };

    $scope.mustSelect = function (event, field) {
        if (event.keyCode == 27) {
            let returnValue = true;
            switch (field) {
                case 'IDCard': $scope.CIFInvestor.IDCardCity = ''; returnValue = false;
                    break;
                case 'Domicile': $scope.CIFInvestor.DomicileCity = ''; returnValue = false;
                    break;
                case 'Correspondence': $scope.CIFInvestor.CorrespondenceCity = ''; returnValue = false;
                    break;
                default:
                    break;
            }
            return returnValue;
        }
        return true;
    }



    var allPromise = $q.all([
        $http({
            method: 'POST',
            url: '/service/client.svc/retrieveSession',
        }).then(function (data) {
            if (!data.data.d) {
                $http({
                    method: 'GET',
                    url: '/service/client.svc/SignOut',
                }).then(function (data) {
                    if (data.data.d == true) {
                        $window.location.href = "#/login";
                        $window.location.reload();
                    }
                }, function (error) { })
            }
            else
                $scope.currentUser = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountry',
            cache: true,
        }).then(function (data) {
            $scope.ListNationality = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountryAll',
            cache: true,
        }).then(function (data) {
            $scope.ListCountry = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {
            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {
            $scope.ListLookup = data.data.d;
            if($scope.ListLookup)
            {
                $scope.ListReligion = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Religion' }, true);
                $scope.ListMarital = $filter('filter')($scope.ListLookup, { CIFLookupID: 'MaritalStatus' }, true);
                $scope.ListEducation = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Educational' }, true);
            }
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFBank',
            cache: true,
        }).then(function (data) {
            $scope.ListBank = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: 'service/client.svc/GetPED',
        }).then(function (data) {

            //if (data.data.d != null) {
            //    $scope.broker = data.data.d;
            //    $scope.user.BrokerCode = $scope.broker.BROKERCode;
            //}
        }, function (error) { }),
    ]);



    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                

                if (data.data.d.BirthDate)
                    $scope.CIFInvestor.BirthDate = new Date(data.data.d.BirthDate);

                if(data.data.d.IDCardCity)
                    $scope.IDCardCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.IDCardCity }, true)[0];

                if (data.data.d.DomicileCity)
                    $scope.DomicileCitySelected = $filter('filter')($scope.ListProvinceCity, { CIFProvinceCityNID: data.data.d.DomicileCity }, true)[0];

                if (data.data.d.Nationality)
                {
                    if (data.data.d.Nationality==102) {
                        $scope.IDLength = 16;
                        $scope.chkSeumurHidup = true;
                        $scope.DisabledSeumurHidup = true;
                        $scope.CIFInvestor.Nationality = 102;
                        $scope.CIFInvestor.IDCardCountry = 102;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[0];
                        $scope.CIFInvestor.IDCardExpireDate = new Date(9998, 11, 31);
                    }
                    else{
                        $scope.IDLength = 8;
                        $scope.chkSeumurHidup = false;
                        $scope.DisabledSeumurHidup = true;
                        $scope.Kewarganegaraan = $scope.KewarganegaraanOption[1];
                        $scope.NationalitySelected = $filter('filter')($scope.ListNationality, { CIFCountryNID: data.data.d.Nationality }, true)[0];
                        $scope.IDCardCountrySelected = $filter('filter')($scope.ListCountry, { CIFCountryNID: data.data.d.IDCardCountry }, true)[0];

                        if (data.data.d.IDCardExpireDate)
                            $scope.CIFInvestor.IDCardExpireDate = new Date(data.data.d.IDCardExpireDate);
                    }
                }
                else
                    $scope.KewarganegaraanChange();

                if(data.data.d.CopyID)
                    $scope.CopyFromID();


            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.prepareData = function () {
        if ($scope.CIFInvestor.CopyID) {
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomicileRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomicileRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.DomicileCitySelected = $scope.IDCardCitySelected;
            //$scope.CIFInvestor.DomicileCountry = $scope.CIFInvestor.IDCardCountry;
        }

        if ($scope.CIFInvestor.AccountStatus)
            $scope.CIFInvestor.AccountStatus = Number($scope.CIFInvestor.AccountStatus);

        if ($scope.CIFInvestor.Sex)
            $scope.CIFInvestor.Sex = Number($scope.CIFInvestor.Sex);

        if ($scope.CIFInvestor.Religion)
            $scope.CIFInvestor.Religion = Number($scope.CIFInvestor.Religion);

        if ($scope.CIFInvestor.Education)
            $scope.CIFInvestor.Education = Number($scope.CIFInvestor.Education);

        if ($scope.CIFInvestor.MaritalStatus)
            $scope.CIFInvestor.MaritalStatus = Number($scope.CIFInvestor.MaritalStatus);

        if ($scope.CIFInvestor.Nationality)
            $scope.CIFInvestor.Nationality = Number($scope.CIFInvestor.Nationality);

        if ($scope.CIFInvestor.IDCardCountry)
            $scope.CIFInvestor.IDCardCountry = Number($scope.CIFInvestor.IDCardCountry);

        if ($scope.CIFInvestor.IDCardCity)
            $scope.CIFInvestor.IDCardCity = Number($scope.CIFInvestor.IDCardCity);

        if ($scope.CIFInvestor.DomicileCity)
            $scope.CIFInvestor.DomicileCity = Number($scope.CIFInvestor.DomicileCity);

        console.log($scope.CIFInvestor);
    }

    $scope.submit = function () {
        $scope.prepareData();
        
        var finished = 0;

        $scope.working = true;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {
                    console.log('DATA', data);
                    swal.close();
                    $window.location.href = "#/cif/data-pekerjaan";
                }, function (error) {
                    swal('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

    $scope.print = function () {
        $scope.prepareData();
    }
}]);


